var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#555555;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,12c2.07,0,3.75-1.68,3.75-3.75S14.07,4.5,12,4.5S8.25,6.18,8.25,8.25S9.93,12,12,12z M14.5,8.25 c0,1.38-1.12,2.5-2.5,2.5s-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5S14.5,6.87,14.5,8.25z M19.5,18.25c0,1.25-1.25,1.25-1.25,1.25H5.75 c0,0-1.25,0-1.25-1.25s1.25-5,7.5-5S19.5,17,19.5,18.25z M18.25,18.24c0-0.31-0.19-1.23-1.04-2.08c-0.81-0.81-2.35-1.66-5.21-1.66 c-2.86,0-4.39,0.85-5.21,1.66c-0.85,0.85-1.04,1.77-1.04,2.08H18.25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUser);
export default __webpack_public_path__ + "static/media/ico_user.bb8d91c8e95512a68a6cb7450d837bca.svg";
export { ForwardRef as ReactComponent };